<mat-toolbar class="d-flex flex-row justify-content-start align-items-center h-100 w-100">

    <h3 class="text-wrap fw-bolder" [innerHTML]="title"></h3>

    <div class="flex-grow-1"></div>

    <button *ngIf="buttonText" type="button" mat-raised-button class="btn ms-2" [routerLink]="buttonUrl">
        <fa-icon *ngIf="buttonIcon" [icon]="['fas', buttonIconName]" class="me-2"></fa-icon>
        <span class="d-none d-lg-inline-block fs-6">{{buttonText}}</span>
    </button>

</mat-toolbar>
